import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faForward, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ForwardTaskModal({
  task,
  employees,
  saving,
  assigneeId,
  note,
  onChangeAssignee,
  onChangeNote,
  onClose,
  onSubmit,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-0 sm:items-center sm:p-4">
      <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 flex min-h-[100dvh] w-full max-w-xl flex-col overflow-hidden bg-white shadow-2xl sm:min-h-0 sm:max-h-[90vh] sm:rounded-3xl">
        <div className="border-b border-slate-200 bg-[linear-gradient(135deg,#0f172a,#1e293b)] px-4 py-4 text-white sm:px-6 sm:py-5">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20 sm:right-5 sm:top-5"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <div className="pr-12">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-slate-100">
              <FontAwesomeIcon icon={faForward} />
              Forward Task
            </div>
            <h3 className="mt-3 text-xl font-semibold sm:text-2xl">{task.title}</h3>
            <p className="mt-2 text-sm text-slate-300">
              Change the assignee when another employee should handle the next action. Once this step is forwarded, that step stays locked.
            </p>
          </div>
        </div>

        <div className="flex-1 space-y-5 overflow-y-auto p-4 sm:p-6">
          <div>
            <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Forward To</label>
            <select
              value={assigneeId}
              onChange={(event) => onChangeAssignee(event.target.value)}
              className="w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-slate-400"
            >
              <option value="">Select employee</option>
              {employees.map((employee) => (
                <option key={employee.id || employee.userId} value={employee.id}>
                  {employee.fullName}
                  {employee.employeeCode ? ` (${employee.employeeCode})` : ""}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Forward Note</label>
            <textarea
              value={note}
              onChange={(event) => onChangeNote(event.target.value)}
              className="min-h-[140px] w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-slate-400"
              placeholder="Example: Need finance review before customer reply."
            />
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-4 py-4 sm:flex-row sm:justify-end sm:px-6 sm:py-5">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-full border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-white sm:w-auto sm:py-2.5"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={saving}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:opacity-70 sm:w-auto sm:py-2.5"
          >
            <FontAwesomeIcon icon={saving ? faSpinner : faArrowRight} spin={saving} />
            {saving ? "Forwarding..." : "Forward Task"}
          </button>
        </div>
      </div>
    </div>
  );
}
